var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FDBF1D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2457_12874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.334 10.6667H10.6673C10.3137 10.6667 9.97456 10.8071 9.72451 11.0572C9.47446 11.3072 9.33398 11.6464 9.33398 12V21.3333C9.33398 21.6869 9.47446 22.0261 9.72451 22.2761C9.97456 22.5262 10.3137 22.6667 10.6673 22.6667H20.0007C20.3543 22.6667 20.6934 22.5262 20.9435 22.2761C21.1935 22.0261 21.334 21.6869 21.334 21.3333V16.6667M20.334 9.66665C20.5992 9.40144 20.9589 9.25244 21.334 9.25244C21.7091 9.25244 22.0688 9.40144 22.334 9.66665C22.5992 9.93187 22.7482 10.2916 22.7482 10.6667C22.7482 11.0417 22.5992 11.4014 22.334 11.6667L16.0007 18L13.334 18.6667L14.0007 16L20.334 9.66665Z",
    stroke: "#0A0A0A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2457_12874"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.89a13ecfc9a544c4556dcba09c1eff90.svg";
export { ForwardRef as ReactComponent };